import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";
import { FileOperationsController } from "@commoncore/controller/FileOperationsController";
import { MemoryController } from "@commoncore/controller/MemoryController";
import { GlobalService } from "@commoncore/services/global.service";
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { addToAlbumController } from "@mainrepo/app/core/controller/addToAlbumController";
import { DependenciesModule } from "@modules/dependencies/dependencies.module";
import { PopUpTabbedViewComponent } from "../../pop-up-tabbed-view/pop-up-tabbed-view.component";
import { CreateAlbumComponent } from "../create-album/create-album.component";

@Component({
  standalone:true,
  selector: "app-add-to-album",
  templateUrl: "./add-to-album.component.html",
  styleUrls: ["./add-to-album.component.scss"],
  imports:[DependenciesModule,PopUpTabbedViewComponent,CreateAlbumComponent]
})
export class AddToAlbumComponent implements OnInit {
  public listService: any;
  public universalService: any;
  @Input() enableButton;
  @Output() close = new EventEmitter();
  @Output() createNewAlbum = new EventEmitter();
  @Output() closecreateModal = new EventEmitter();
  @Output() gotoPreviousScreen = new EventEmitter();
  @Output() createAlbumValidation = new EventEmitter();
  showAddToAlbumModal:boolean = false;
  controller: any;
  addToAlbumController:any
  implRef: any;
  albumsList:any;
  loggerService: any;
  selectedTab: any;
  http: any;
  tabDetails: any;
  tabData: any;
  router:any
  memoriesController: MemoryController;
  cleverTapEventsService:any;

  constructor(public globalService: GlobalService,private changeDetector: ChangeDetectorRef){
    this.setEnvObjects(globalService);
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.showAddToAlbumModal && !this.listService.createAlbumObject) {
      if(this.router.url.includes("/memory")){
        this.universalService.disableModalBackdrop();
        $('#add-to-jiocloud-modal .gridItem').removeClass('grid_info');
        this.showAddToAlbumModal = false;
        AppEvents.memorySubscriptions.next({'decidetimer':true});
      }else{
        this.listService.deSelectAll(event)
      }
    }
  }
  
  ngOnInit(): void {
    let classRef = this;
    this.controller = FileOperationsController.getInstance(this.globalService);
    this.implRef = this.controller.fileOperationsImplementation;
    this.controller.setEnvObjects(this.globalService);
    this.addToAlbumController = addToAlbumController.getInstance(this.globalService);
    this.addToAlbumController.setEnvObjects(this.globalService);
    this.listService.createAlbumObject = false;
    this.addToAlbumController.setEnvObjects(this.globalService);
    
    AppEvents.optionSelected.subscribe(event => {
      console.log("addtoalbum", event);
      if(event["addtoalbum"]){
        this.registerEvents();
        classRef.decidePopUpTabbedViews();
        this.selectedTab = undefined;
        classRef.showAddToAlbumModal = event["addtoalbum"];
        classRef.universalService.pauseMemoryTimer();
        var selectedFiles = event["filesList"] ? event["filesList"] : this.universalService.selectedNodes;
        this.setFileDataForAddToAlbum(selectedFiles,'myAlbums');
        classRef.changeDetector.detectChanges();
      } else if(event["closeAll"]){
        classRef.showAddToAlbumModal = false;
        classRef.changeDetector.detectChanges();
        classRef.universalService.decideMemoryTimer();
      }
    })
    
  } 

  decidePopUpTabbedViews(){
    var registeredEvents = AppEvents.getRegisteredEvents();
    if(registeredEvents.includes(EventsList.ADD_TO_ALBUM_MODAL_TABBED_VIEW)){
      AppEvents.emit(EventsList.ADD_TO_ALBUM_MODAL_TABBED_VIEW);
    }
  }

  setEnvObjects(globalService) {
    this.listService = globalService.getListServiceRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.http = globalService.getHttpClientRef();
    this.router = globalService.getRouterRef();
    this.memoriesController = MemoryController.getInstance(this.globalService);
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
  }

  registerEvents(){
    this.universalService.removePopUpEventListeners();
    let classRef = this;
    console.log("classRef.universalService.PopUpTabClicked",classRef.universalService.PopUpTabClicked)
    AppEvents.on(EventsList.POP_UP_TAB_CLICKED, function(tabDetails){
      classRef.tabDetails = tabDetails;
      console.log("inside pop up tab clicked from move copy component")
      classRef.switchTabs(classRef.universalService.PopUpTabClicked)
    })
    AppEvents.on(EventsList.POPUP_TABBED_VIEW_READY, function(tabDetails){
      classRef.decidePopUpTabbedViews();
    })
  }

  async setFileDataForAddToAlbum(files,albumType){
    this.universalService.showLoader= true;
    await this.addToAlbumController.setFileDataForAddToAlbum(files);
    this.universalService.showLoader = false;
    setTimeout(()=>{
      this.listService.applicationRef.tick();
    },100)
  }

  async getAllAlbumMetaData(albumType){
    this.albumsList = await this.addToAlbumController.getAllAlbumMetaData(albumType);
    console.log("albumsList",this.albumsList)
  }

  closePopUp() {
    if(this.universalService.currentMemory){
      this.cleverTapEventsService.memoryAddToAlbumClicked(this.universalService.currentMemory["spotLightKey"],'Not Added to Albums');
      let memoryPayload = {
        "featureCode": "SPT",
        "cardUniqueCode": this.universalService.currentMemory["spotLightKey"],
        "cardActionCode": 'User_SpotlightAlbums_Clicked',
        "cardActionData" : {
          "SpotlightId": this.universalService.currentMemory["spotLightKey"],
          "Status" : "Not Added to Albums"
        }
      }
      this.memoriesController.sendMemoryAnalytics(memoryPayload);
    }
    $('#add-to-jiocloud-modal .gridItem').removeClass('grid_info');
    this.close.emit();
    this.showAddToAlbumModal = false;
  }

  createAlbum() {  
    this.createNewAlbum.emit();
    AppEvents.globalObservable.next({createAlbum: true});
    setTimeout(()=>{
      let el = document.getElementById('custome_backdrop')
      if(el){
        el.style.display = 'none';
      }
    },40);
  }

  addToAlbum(){
    if(this.universalService.currentMemory){
      this.cleverTapEventsService.memoryAddToAlbumClicked(this.universalService.currentMemory["spotLightKey"],'Added to Albums');
      let memoryPayload = {
        "featureCode": "SPT",
        "cardUniqueCode": this.universalService.currentMemory["spotLightKey"],
        "cardActionCode": 'User_SpotlightAlbums_Clicked',
        "cardActionData" : {
          "SpotlightId": this.universalService.currentMemory["spotLightKey"],
          "Status" : "Added to Albums"
        }
      }
      this.memoriesController.sendMemoryAnalytics(memoryPayload)
    }
    this.addToAlbumController.addToAlbumApi();
  }

  closeCreateModal() {
    if(this.universalService.currentMemory){
      this.cleverTapEventsService.memoryAddToAlbumClicked(this.universalService.currentMemory["spotLightKey"],'Not Added to Albums');
      let memoryPayload = {
        "featureCode": "SPT",
        "cardUniqueCode": this.universalService.currentMemory["spotLightKey"],
        "cardActionCode": 'User_SpotlightAlbums_Clicked',
        "cardActionData" : {
          "SpotlightId": this.universalService.currentMemory["spotLightKey"],
          "Status" : "Not Added to Albums"
        }
      }
      this.memoriesController.sendMemoryAnalytics(memoryPayload);
    }
    this.closecreateModal.emit();
  }

  async createAlbumAndAdd(){
    if(this.universalService.currentMemory){
      this.cleverTapEventsService.memoryAddToAlbumClicked(this.universalService.currentMemory["spotLightKey"],'Added to Albums');
      let memoryPayload = {
        "featureCode": "SPT",
        "cardUniqueCode": this.universalService.currentMemory["spotLightKey"],
        "cardActionCode": 'User_SpotlightAlbums_Clicked',
        "cardActionData" : {
          "SpotlightId": this.universalService.currentMemory["spotLightKey"],
          "Status" : "Added to Albums"
        }
      }
      this.memoriesController.sendMemoryAnalytics(memoryPayload)
    }
    await this.addToAlbumController.createAlbumAndAdd(this.implRef.albumName);
    this.universalService.popUpToBeOpened = "";
  }

  goBackToPreviousScreen() {
    this.gotoPreviousScreen.emit();
  }

  validateBeforeCreatingAlbum(value) {
    this.createAlbumValidation.emit(value);
  }

  selectPhoto(event,brd){
    $('#add-to-jiocloud-modal .gridItem').removeClass('grid_info');
    var currentElement = event.target;
    currentElement.closest('.gridItem').classList.add('grid_info')
    this.universalService.selectedFile = brd["FullObject"];
    this.universalService.objectSelected = true;
  }

  switchTabs(tabName){
    this.universalService.objectSelected = false;
    if(!this.selectedTab || (this.selectedTab["id"] != tabName && tabName == "myAlbums")){
      this.getAllAlbumMetaData('myAlbums');
      $('#add-to-jiocloud-modal .gridItem').removeClass('grid_info');
      this.selectedTab = this.tabDetails[0];
    }else if (tabName == "sharedalbums"){
      this.getAllAlbumMetaData('sharedAlbums');
      $('#add-to-jiocloud-modal .gridItem').removeClass('grid_info');
      this.selectedTab = this.tabDetails[1];
    }
  }

  thumbnailError(e){
    e.target.src = ' ';
    if(e.target.src == ''){
      e.target.style.display = 'none';
    }  
  }
  // pickRandomColor(event,brdName) {
  //   var colors = [
  //     "#1abc9c",
  //     "#2ecc71",
  //     "#3498db",
  //     "#9b59b6",
  //     "#34495e",
  //     "#d35400",
  //     "#e74c3c",
  //     "#009432",
  //     "#0652DD",
  //     "#B53471",
  //     "#ED4C67",
  //     "#6F1E51",
  //     "#1B1464",
  //     "#006266",
  //     "#17c0eb",
  //     "#1B9CFC",
  //     "#3B3B98",
  //     "#B33771",
  //     "#6D214F",
  //     "#1e3799",
  //   ];
  //   var hash = 0;
  //   if (albumName.boardName) {
  //     for (var i = 0; i < albumName.boardName.length; i++) {
  //       hash = albumName.boardName.charCodeAt(i) + ((hash << 5) - hash);
  //     }
  //   } else {
  //     for (var i = 0; i < albumName.length; i++) {
  //       hash = albumName.charCodeAt(i) + ((hash << 5) - hash);
  //     }
  //   }
  //   var index = Math.abs(hash % (colors.length - 1));
  //   let target = event.target;
  //   let target_parent = target.parentNode.id
  //   let parent_ele = (document.querySelector("#"+target_parent)) as any
  //   parent_ele.style.backgroundColor = colors[index];
  //   let img_el = (document.querySelector('#'+ target_parent + ' img')) as any;
  //   img_el.style.display = 'none';
  // }

  getNameInitailChar(firstName,lastName) { 
    if(!firstName || !lastName){
      return
    }
    let fullName = firstName + ' ' + lastName;
    return fullName.split(' ').map(n => n[0]).join('');
  }
}
